export class Agency {
    name = '';
    code = '';
    status = '';
}